import React, { useEffect } from 'react';
import { PlayerEnum } from '../Player/constants';
import { IPlayerName } from '../../../../shared/types/player.type';
import PlayerNamesContext from '../StatusPanel/PlayerNames/PlayerNamesContext';

interface Props {
  changes: string[];
}

/**
 * this function takes the names (taken from the context) and returns a function, that can be used in
 * a .map function of a string array. It then replaces the placeholder ${0}, ${1}, ... with the matching
 * Player names.
 * it defaults to return the original string
 */
const enrichStringWithPlayerNames =
  ({ names }: { names: IPlayerName[] }) =>
  (change: string): string =>
    change.replace(/\${(\d)}/, (...match) => {
      switch (Number(match[1]) as PlayerEnum) {
        case PlayerEnum.ONE:
          return (
            names.find((n) => n.player === PlayerEnum.ONE)?.name || 'Player 1'
          );
        case PlayerEnum.TWO:
          return (
            names.find((n) => n.player === PlayerEnum.TWO)?.name || 'Player 2'
          );
        case PlayerEnum.THREE:
          return (
            names.find((n) => n.player === PlayerEnum.THREE)?.name || 'Player 3'
          );
        case PlayerEnum.FOUR:
          return (
            names.find((n) => n.player === PlayerEnum.FOUR)?.name || 'Player 4'
          );
        default:
          return match[0];
      }
    });

const enrichChangesWithPlayerNames = ({
  changes,
  names,
}: {
  changes: string[];
  names: IPlayerName[];
}): string => changes.map(enrichStringWithPlayerNames({ names })).join('\n');

const ChangesLog: React.FC<Props> = (props) => {
  const { names } = React.useContext(PlayerNamesContext);
  const ref = React.useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    // scroll to bottom after we render the textfield with the latest change so scrollHeight is also the latest
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight + 10;
    }
  });

  const changesValue = enrichChangesWithPlayerNames({
    changes: props.changes,
    names,
  });

  return (
    <textarea rows={15} cols={40} disabled ref={ref} value={changesValue} />
  );
};

export default ChangesLog;
